<template>
    <div class="animated fadeIn">
        <component-new-header
            title="Action Workflows"
            :isLoading="loading"
            @reload-data="$apollo.queries.workflows.refetch()"
            @create-press="$router.push('/setup/workflows/create')"
            createButtonText="Create Workflow"
            :hasCreate="true"
            :hasback="false"
            :hasDropdown="false"
            :has-search="false"
        >
            <template v-slot:heading-actions>
                <b-button
                    size="sm"
                    variant="success"
                    class="my-2 ml-2 my-sm-0 btn-primary"
                    @click="$router.push('/setup/workflows/mappings')"
                    >Mappings
                </b-button>
                <b-button
                    size="sm"
                    variant="success"
                    class="my-2 ml-2 my-sm-0 btn-primary"
                    @click="$router.push('/setup/workflows/history')"
                    >History
                </b-button>
            </template>
        </component-new-header>
        <b-card class="card-wrap" border-variant="info">
            <b-table
                :items="workflows"
                :fields="workflowColumns"
                :per-page="perPage"
                :current-page="currentPage"
                :busy="loading"
                :hover="true"
                :dark="false"
                :striped="false"
                :bordered="false"
                :small="false"
                :fixed="false"
            >
                <template slot="cell(execute)" slot-scope="data">
                    <b-button
                        size="sm"
                        class="button-circle mr-2"
                        variant="primary"
                        @click="executeWorkflow(data.item)"
                    >
                        <i class="fa fa-play"></i>
                    </b-button>
                </template>
                <template slot="cell(createTime)" slot-scope="data">
                    <span>{{
                        new Date(data.item.createTime).toLocaleDateString()
                    }}</span>
                </template>
                <template slot="cell(action)" slot-scope="data">
                    <div class="inline_btnTable">
                        <b-button
                            size="sm"
                            class="button-circle mr-2"
                            variant="primary"
                            @click="
                                $router.push(
                                    '/setup/workflows/update/' +
                                        data.item.name +
                                        '/' +
                                        data.item.version,
                                )
                            "
                        >
                            <i class="fa fa-pencil"></i>
                        </b-button>

                        <b-button
                            size="sm"
                            class="button-circle mr-2"
                            variant="danger"
                        >
                            <i class="fa fa-trash"></i>
                        </b-button>
                    </div>
                </template>
            </b-table>
            <!--            <h1>Workflow List</h1>-->
            <!--            <ul>-->
            <!--                <li v-for="workflow in workflows" :key="workflow.id">-->
            <!--                    <h2>{{ workflow.name }}</h2>-->
            <!--                    <p>{{ workflow.description }}</p>-->
            <!--                    <p>-->
            <!--                        Created at:-->
            <!--                        {{ new Date(workflow.createdAt).toLocaleDateString() }}-->
            <!--                    </p>-->
            <!--                </li>-->
            <!--            </ul>-->
        </b-card>
        <template v-if="run.version && run.name">
            <execute
                :open="true"
                :name="run.name"
                :version="run.version"
                @close="run = {}"
            />
        </template>
    </div>
</template>

<script>
import gql from "graphql-tag";
import ComponentNewHeader from "@/components/componentNewHeader/index.vue";
import Execute from "@/views/workflows/components/execute.vue";

export default {
    components: { Execute, ComponentNewHeader },
    data() {
        return {
            workflows: [],
            currentPage: 1,
            perPage: 10,
            totalWorkflows: 0,
            loading: false,
            run: {},
            workflowColumns: [
                {
                    key: "execute",
                    label: "Execute",
                },
                {
                    key: "name",
                    label: "Name",
                    sortable: true,
                },
                {
                    key: "version",
                },
                {
                    key: "description",
                },
                {
                    key: "createTime",
                },
                {
                    key: "createdBy",
                },
                {
                    key: "action",
                },
            ],
        };
    },
    methods: {
        createWorkflow() {},
        executeWorkflow(data) {
            this.run = {
                name: data.name,
                version: data.version,
            };
        },
    },
    apollo: {
        workflows: {
            query: gql`
                query getWorkflowList {
                    getWorkflowList {
                        name
                        version
                        description
                        ownerEmail
                        timeoutSeconds
                        createdBy
                        updatedBy
                        createTime
                        updateTime
                        historyId
                        readOnly
                    }
                }
            `,
            update: (data) => data.getWorkflowList || [],
            result({ data }) {
                this.totalWorkflows = (data.getWorkflowList || []).length;
            },
        },
    },
};
</script>
